/**
 * 项目全局配置
 */
const appConfig = {
  name: "营养减重服务平台",//项目名
  version: "1.0.0",//版本号
  miniAppId: "wx76b3e96b5b28d498",//小程序appId
  // wxAppId: "wx07f3a380dbc07549",//公众号appId
}

export default appConfig 